/**
 * MenuItem value for explicit "All branches" in MUI Select `multiple`.
 * onChange handlers must clear branch filters when this value is present.
 */
export const REPORT_BRANCH_MULTISELECT_ALL_SENTINEL = "__all_branches__";
